import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { UsersThree, ShieldCheck, HandCoins, PaperPlaneTilt, Vault } from "@phosphor-icons/react";
import { formatCLP } from "../../lib/format";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [loans, setLoans] = useState([]);

  useEffect(() => {
    api.get("/stats/overview").then((r) => setStats(r.data));
    api.get("/loans", { params: { status: "pendiente" } }).then((r) => setLoans(r.data));
  }, []);

  if (!stats) return <div className="text-inkMuted">Cargando…</div>;

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Overview · Administrador</div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter">Centro de control</h1>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-0 border border-hairline bg-surface">
        <Metric icon={UsersThree} label="Usuarios totales" value={stats.total_users} />
        <Metric icon={UsersThree} label="Clientes" value={stats.clients} border />
        <Metric icon={ShieldCheck} label="Asesores" value={stats.advisors} border />
        <Metric icon={ShieldCheck} label="Admins" value={stats.admins} />
      </div>

      <div className="grid md:grid-cols-3 gap-0 border border-hairline bg-surface">
        <Metric icon={Vault} label="Saldo total en cuentas" value={formatCLP(stats.total_balance)} mono />
        <Metric icon={HandCoins} label="Créditos pendientes" value={stats.pending_loans} border />
        <Metric icon={PaperPlaneTilt} label="Transferencias totales" value={stats.total_transfers} />
      </div>

      <div className="bento">
        <div className="px-6 py-4 border-b border-hairline"><h2 className="font-display text-xl font-bold">Últimos créditos pendientes</h2></div>
        {loans.length === 0 ? (
          <div className="p-10 text-center text-inkMuted text-sm">Sin pendientes.</div>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="label-mono border-b border-hairline">
              <th className="px-6 py-3 text-left">Cliente</th>
              <th className="px-6 py-3 text-right">Monto</th>
              <th className="px-6 py-3 text-left">Cuotas</th>
              <th className="px-6 py-3 text-left">Motivo</th>
            </tr></thead>
            <tbody>
              {loans.slice(0, 5).map((l) => (
                <tr key={l.id} className="border-b border-hairline">
                  <td className="px-6 py-3 font-semibold">{l.client_name}</td>
                  <td className="px-6 py-3 text-right font-mono">{formatCLP(l.amount)}</td>
                  <td className="px-6 py-3">{l.cuotas}</td>
                  <td className="px-6 py-3 text-inkMuted">{l.purpose || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function Metric({ icon: Icon, label, value, mono, border }) {
  return (
    <div className={`p-6 ${border ? "border-x border-hairline" : ""}`}>
      <Icon size={22} weight="duotone" className="text-forest mb-5" />
      <div className="label-mono">{label}</div>
      <div className={`font-display text-4xl font-black mt-1 ${mono ? "font-mono" : ""}`}>{value}</div>
    </div>
  );
}
